import ParentList from '@/controllers/parent/parent-list.js';

export default {
  extends: ParentList,
}
